// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"415":"85c756f9","3040":"f99fdc09","6066":"852ab770","7179":"657f1d8c","8820":"f5b142dd"}[chunkId] + ".chunk.css";
};